import { render } from "./PricingPlansBoxes.vue?vue&type=template&id=1fdfa0e8"
import script from "./PricingPlansBoxes.vue?vue&type=script&lang=js"
export * from "./PricingPlansBoxes.vue?vue&type=script&lang=js"

import "./PricingPlansBoxes.vue?vue&type=style&index=0&id=1fdfa0e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__